import { ApiProperty } from "@nestjs/swagger";

export class PlantItemSubCategoryIdReq{
    unitId?:number;
    itemSubCategoryId?:number;
}